
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'dissociate': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.833333C10 0.373333 10.3733 0 10.8333 0H19.1667C19.6267 0 20 0.373333 20 0.833333V10.8333C20 11.2933 19.6267 11.6667 19.1667 11.6667H15V15C15 15.4602 14.6269 15.8333 14.1667 15.8333H10V19.1667C10 19.6267 9.62667 20 9.16667 20H0.833333C0.373333 20 0 19.6267 0 19.1667V9.16667C0 8.70667 0.373333 8.33333 0.833333 8.33333H5V5C5.00005 4.53978 5.37312 4.16671 5.83333 4.16667H10V0.833333ZM13.3333 14.1667V5.83333H6.66667V8.33333H9.16667C9.62667 8.33333 10 8.70667 10 9.16667V14.1667H13.3333Z" fill="#93A0AE"/>'
  }
})
